import { Button, InputNumber, Modal, Space, Typography } from 'antd';
import { useEffect, useState } from 'react';

export type HinhThucThanhToan = 'TIEN_MAT' | 'CHUYEN_KHOAN_NGAN_HANG';

const formatMoney = (value: number) =>
  new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(value);

const { Text } = Typography;

type TinhTienModalProps = {
  open: boolean;
  selectedTableName?: string;
  total: number;
  confirmLoading?: boolean;
  onConfirm: (paymentMethod: HinhThucThanhToan) => void;
  onPrint?: (cashReceived: number) => void;
  onCancel: () => void;
};

export default function TinhTienModal({
  open,
  selectedTableName,
  total,
  confirmLoading = false,
  onConfirm,
  onPrint,
  onCancel,
}: TinhTienModalProps) {
  const [cashReceived, setCashReceived] = useState(0);

  useEffect(() => {
    if (open) {
      setCashReceived(0);
    }
  }, [open, total]);

  const changeDue = Math.max(cashReceived - total, 0);

  return (
    <Modal
      title={`Tính tiền cho ${selectedTableName || 'bàn'}`}
      open={open}
      width={650}
      onCancel={onCancel}
      footer={
        <Space wrap style={{ width: '100%', justifyContent: 'flex-end' }}>
          {onPrint ? (
            <Button
              style={{ backgroundColor: '#fa8c16', borderColor: '#fa8c16', color: '#fff' }}
              onClick={() => onPrint(cashReceived)}
            >
              In hóa đơn
            </Button>
          ) : null}
          <Button
            style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: '#fff' }}
            onClick={() => onConfirm('CHUYEN_KHOAN_NGAN_HANG')}
            loading={confirmLoading}
          >
            Thanh toán chuyển khoản
          </Button>
          <Button
            type="primary"
            onClick={() => onConfirm('TIEN_MAT')}
            loading={confirmLoading}
          >
            Thanh toán tiền mặt
          </Button>
          <Button onClick={onCancel}>Hủy</Button>
        </Space>
      }
    >
      <p style={{ margin: 0 }}>
        Tổng tiền cần thanh toán: <strong>{formatMoney(total)}</strong>
      </p>
      <Space direction="vertical" style={{ width: '100%', marginTop: 16 }}>
        <div>
          <Text strong>Tiền khách đưa</Text>
          <InputNumber
            aria-label="Tiền khách đưa"
            min={0}
            precision={0}
            value={cashReceived}
            onChange={(value) => setCashReceived(typeof value === 'number' ? value : 0)}
            formatter={(value) =>
              `${value ?? ''}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            }
            parser={(value) => Number((value ?? '').replace(/\./g, ''))}
            style={{ width: '100%', marginTop: 8 }}
          />
        </div>
        <p style={{ margin: 0 }}>
          Tiền thối lại: <strong>{formatMoney(changeDue)}</strong>
        </p>
      </Space>
    </Modal>
  );
}
